<template>
    <div class="day-data-wrapper">
        <van-nav-bar
            title="每日数据"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <div class="main-wrapper">
            <div class="header-total">
                <div class="select-wrapper">
                    <div class="select-item">
                        <div @click="startTimePicker = true">
                            <span>{{ startTimeValue }}</span>
                            <i class="iconfont iconxiala"></i>
                        </div>
                        <p>—</p>
                        <div @click="endTimePicker = true">
                            <span>{{ endTimeValue }}</span>
                            <i class="iconfont iconxiala"></i>
                        </div>
                    </div>
                    <div
                        class="select-item Station"
                        @click="showPicker = true"
                    >
                        <span>{{ StationName }}</span>
                        <i class="iconfont iconxiala"></i>
                    </div>
                </div>
                <ul class="total-list">
                    <li>
                        <p><i class="iconfont icontijikongjian"></i>总任务(个)</p>
                        <span>{{ totalCount.rws || 0 }}</span>
                    </li>
                    <li>
                        <p><i class="iconfont icontijikongjian"></i>任务方量(方)</p>
                        <span>{{ totalCount.rwfl || 0 }}</span>
                    </li>
                    <li class="active">
                        <p><i class="iconfont icontijikongjian"></i>销售方量(方)</p>
                        <span>{{ totalCount.xsfl || 0 }}</span>
                    </li>
                    <li>
                        <p><i class="iconfont icontongji1"></i>完成率(%)</p>
                        <span>{{ totalCount.wcl || 0 }}</span>
                    </li>
                </ul>
                <div class="produce-detail">
                    <div>
                        <div class="item-wrapper">
                            <span>{{ totalCount.fhfl || 0 }}</span>
                            <p>发货方量</p>
                        </div>
                        <div class="item-wrapper">
                            <span>{{ totalCount.ddpdl || 0 }}</span>
                            <p>调度派单量</p>
                        </div>
                        <div class="item-wrapper">
                            <span>{{ totalCount.scfl || 0 }}</span>
                            <p>生产方量</p>
                        </div>
                        <div class="item-wrapper item-active">
                            <span>{{ totalCount.ccgbl || 0 }}</span>
                            <p>出厂过磅量</p>
                        </div>
                        <div class="item-wrapper">
                            <span>{{ totalCount.sjqsfl || 0 }}</span>
                            <p>司机卸料方量</p>
                        </div>
                    </div>
                    <div>
                        <div class="item-wrapper">
                            <span>{{ totalCount.khqsfl || 0 }}</span>
                            <p>客户签收方量</p>
                        </div>
                        <div class="item-wrapper">
                            <span>{{ totalCount.ttfl || 0 }}</span>
                            <p>剩退方量</p>
                        </div>
                        <div class="item-wrapper">
                            <span>{{ totalCount.zffl || 0 }}</span>
                            <p>转发方量</p>
                        </div>
                        <div class="item-wrapper">
                            <span>{{ totalCount.pyfl || 0 }}</span>
                            <p>盘盈方量</p>
                        </div>
                        <div class="item-wrapper">
                        </div>
                    </div>
                </div>
            </div>
            <div class="chart-wrapper">
                <div class="chart-box">
                    <div class="chart-name">
                        <p>生产方量对比</p>
                        <p class="btn-type">
                            <span
                                v-for="(item,index) in btnData"
                                :key="index"
                                :class="{'active-btn': activeIndex === index}"
                                @click="toggle(index,item.type)"
                            >{{ item.name }}</span>
                        </p>
                    </div>
                    <div id="myChart" class="my-chart"></div>
                </div>
            </div>
            <div class="ranking-wrapper">
                <p>客户要料排名</p>
                <ul v-if="RankData.length > 0">
                    <li class="ranking-item" v-for="(item,index) in RankData" :key="index">
                        <div class="left-img">
                            <img v-if="index=== 0" src="@/assets/images/materialStatistics/rank_1@2x.png" alt="暂无图片">
                            <img v-else-if="index=== 1" src="@/assets/images/materialStatistics/rank_2@2x.png" alt="暂无图片">
                            <img v-else-if="index=== 2" src="@/assets/images/materialStatistics/rank_3@2x.png" alt="暂无图片">
                            <img v-else src="@/assets/images/home/m_zw.png" alt="暂无图片">
                        </div>
                        <div class="right-content">
                            <p>客户名称：{{ item.khmc }}</p>
                            <ol>
                                <li>
                                    <strong>{{ item.rwfl || 0 }}</strong>
                                    <span>任务方量(方)</span>
                                </li>
                                <li>
                                    <strong>{{ item.scfl || 0 }}</strong>
                                    <span>生产方量(方)</span>
                                </li>
                                <li>
                                    <strong>{{ item.wcl ? parseInt(item.wcl*100) : 0 }}</strong>
                                    <span>完成率(%)</span>
                                </li>
                            </ol>
                        </div>
                    </li>
                </ul>
                <span v-else class="empty-wrapper">暂无数据</span>
            </div>
        </div>

        <!-- 开始时间 -->
        <van-popup
            v-model="startTimePicker"
            position="bottom"
            :overlay="true"
        >
            <van-datetime-picker
                v-model="startCurrentDate"
                type="date"
                title="选择年月日"
                @confirm="startConfirmData"
                @cancel="startTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
        <!-- 结束时间 -->
        <van-popup
            v-model="endTimePicker"
            position="bottom"
            :overlay="true"
        >
            <van-datetime-picker
                v-model="endCurrentDate"
                type="date"
                title="选择年月日"
                @confirm="endConfirmData"
                @cancel="endTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
        <!-- 选择场站 -->
        <van-popup
            v-model="showPicker"
            position="bottom"
        >
            <van-picker
                show-toolbar
                :columns="columns"
                @cancel="showPicker = false"
                @confirm="onConfirm"
            ></van-picker>
        </van-popup>
    </div>
</template>


<script>
import bg_blue from '../../../assets/images/home/bg_blue_l.png';
import bg_orange from '../../../assets/images/home/bg_orange_l.png';
import { Toast } from 'vant';
export default {
    data() {
        return {
            // 开始时间text
            startTimeValue: '',
            // 结束时间text
            endTimeValue: '',
            // 开始时间弹出层
            startTimePicker: false,
            // 结束时间弹出层
            endTimePicker: false,
            // 开始时间默认日期
            startCurrentDate: new Date(),
            // 结束时间默认日期
            endCurrentDate: new Date(),
            // isShow: false,
            // 场站弹出层状态
            showPicker: false,
            // timeValue: '',
            // 场站待选数据集合
            columns: [],
            // 场站名称
            StationName: '',
            // 场站id
            StationId: '',
            // 场站初始化数据待选数据
            StationData: [
                {
                    station_id: '',
                    station_name: '全部',
                },
            ],
            // 头部任务数据
            totalCount: {},
            // 统计图数据
            ChartData: [],
            // 客户要料排名数据集合
            RankData: [],
            // tab 数据
            btnData: [
                {
                    name: '按场站',
                    type: 1,
                },
                {
                    name: '按标号',
                    type: 2,
                },
            ],
            // tab默认选择下标
            activeIndex: 0,
        };
    },
    created() {
        this.startTimeValue = this.formatDate(this.startCurrentDate);
        this.endTimeValue = this.formatDate(this.endCurrentDate);
    },
    watch: {
        startTimeValue(newVal) {
            if (newVal !== '') {
                if (this.StationData.length < 2) {
                    // 获取场站
                    this.getStationList();
                } else {
                    this.getStatistics();
                }
            }
        },
        endTimeValue() {
            this.getStatistics();
        },
        StationId() {
            this.getStatistics();
        },
    },
    mounted() {
        // 初始化页面方法
        // this.init();
    },
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 获取企业下所有场站
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        station_name: stationNames[index],
                    };
                });
                this.StationData.push(...stationList);
                this.columns = this.StationData.map(item => item.station_name);
                this.StationName = this.columns[0];
                this.StationId = this.StationData[0].station_id;
                this.getStatistics();
            }
        },
        async getStatistics() {
            this.getDayCount();
            if (this.activeIndex === 0) {
                this.getLineChart();
            } else if (this.activeIndex === 1) {
                this.getGradeChart();
            }
            this.getCustomerRank();
        },
        // 每日数据-总任务、任务方量、生产方量、完成率
        getDayCount() {
            this.$axios
            // eslint-disable-next-line max-len
                .get(`/interfaceApi/report/tjfx/mrsj/new/tjs?station_id=${this.StationId}&start_time=${this.startTimeValue}&end_time=${this.endTimeValue}`)
                .then(res => {
                    this.totalCount = res;
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        // 每日数据-生产方量对比-按生产线
        getLineChart() {
            this.$axios
            // eslint-disable-next-line max-len
                .get(`/interfaceApi/report/tjfx/mrsj/new/scfldb/ascx?station_id=${this.StationId}&start_time=${this.startTimeValue}&end_time=${this.endTimeValue}`)
                .then(res => {
                    this.ChartData = res;
                    this.myChart();
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        // 每日数据-生产方量对比-按标号
        getGradeChart() {
            this.$axios
            // eslint-disable-next-line max-len
                .get(`/interfaceApi/report/tjfx/mrsj/new/scfldb/abh?station_id=${this.StationId}&start_time=${this.startTimeValue}&end_time=${this.endTimeValue}`)
                .then(res => {
                    this.ChartData = res;
                    this.setChartHeight();
                    this.myChart();
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        // 每日数据-客户要料排名
        getCustomerRank() {
            this.$axios
            // eslint-disable-next-line max-len
                .get(`/interfaceApi/report/tjfx/mrsj/new/khylpm?station_id=${this.StationId}&start_time=${this.startTimeValue}&end_time=${this.endTimeValue}`)
                .then(res => {
                    this.RankData = res;
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },

        // tab切换
        toggle(index, type) {
            this.activeIndex = index;
            if (type === 2) {
                this.getGradeChart();
            } else {
                this.getLineChart();
            }
        },
        // 确认选择开始时间
        startConfirmData(val) {
            this.startTimeValue = this.formatDate(val);
            this.startTimePicker = false;
        },
        // 确认选择结束时间
        endConfirmData(val) {
            this.endCurrentDate = val;// 结束时间默认日期
            this.endTimePicker = false;
            this.endTimeValue = this.formatDate(val);
        },
        // 时间对象格式化
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        // 切换场站
        onConfirm(val, index) {
            this.showPicker = false;
            this.StationName = this.StationData[index].station_name;
            this.StationId = this.StationData[index].station_id;
            if (val === '全部') {
                this.btnData[0].name = '按场站';
            } else {
                this.btnData[0].name = '按生产线';
            }
        },

        // 防止重叠，动态设置myChart高度
        setChartHeight() {
            const defultHeight = 80;
            const baseH = 20;
            const newDom = document.getElementById('myChart');
            if (this.ChartData.length > 5) {
                const diff = this.ChartData.length - 5;
                newDom.style.height = diff * baseH + defultHeight + 'vw';
            } else {
                newDom.style.height = defultHeight + 'vw';
            }
        },
        myChart() {
            this.setChartHeight();
            const newDom = document.getElementById('myChart');
            if (!newDom) {return;}
            const myChart = this.$echarts.init(newDom);
            myChart.resize();
            const xdata = [];
            const ydata = [
                {
                    name: '发货方量',
                    colors: ['#3E79C5', '#55A7FE'],
                    labelBg: bg_blue,
                    labelColor: '#55A7FE',
                    data: [],
                },
                {
                    name: '生产方量',
                    colors: ['#FA8C47', '#EFAB54'],
                    labelBg: bg_orange,
                    labelColor: '#F98F48',
                    data: [],
                },
            ];
            this.ChartData.forEach(item => {
                xdata.push(item.name);
                ydata[0].data.push(item.fhfl);
                ydata[1].data.push(item.scfl);
            });
            const option = {
                grid: {
                    left: 50,
                    top: 50,
                    bottom: 30,
                    right: 30,
                },
                legend: {
                    show: true,
                    top: 0,
                    right: 0,
                    data: ['发货方量', '生产方量'],
                    textStyle: {
                        color: '#666666',
                        fontSize: 12,
                    },
                },
                yAxis: {
                    data: xdata,
                    nameLocation: 'end',
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            color: '#979EA7',
                            fontSize: 12,
                        },
                    },
                },
                xAxis: [{
                    splitNumber: 4,
                    name: '(方)',
                    position: 'top',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#979EA7',
                            fontSize: 12,
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: [],
            };
            ydata.forEach(item => {
                option.series.push({
                    name: item.name,
                    type: 'bar',
                    barGap: '50%',
                    label: {
                        show: true,
                        position: 'right',
                        distance: 25,
                        color: item.labelColor,
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        align: 'center',
                        lineHeight: 22,
                        padding: [0, 10, 4, 10],
                        backgroundColor: {
                            image: item.labelBg,
                        },
                        height: 15,
                        // rotate: -90,
                    },
                    animationEasing: 'elasticOut',
                    barWidth: 15,
                    itemStyle: {
                        normal: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: item.colors[1], //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: item.colors[0], //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            opacity: 1,
                        },
                    },
                    data: item.data,
                    z: 10,
                });
            });
            myChart.setOption(option);
        },
    },
};
</script>

<style lang="stylus">
    .day-data-wrapper
        width 100%
        height 100%
        background #F0F0F0
        .main-wrapper
            height calc(100% - 45rpx)
            overflow-y auto
        .header-total
            background #ffffff
            padding 15rpx
            .select-wrapper
                height 45rpx
                box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16)
                border-radius 8px
                display flex
                .select-item
                    flex 1
                    text-align center
                    span
                        font-size 14rpx
                        font-weight 400
                        line-height 45rpx
                    i
                        color #979EA7
                    &:first-child
                        flex 2
                        display flex
                        div
                            flex 1
                        p
                            line-height 45rpx
                            color #979EA7
                            font-weight 400
                .Station
                    span
                        color #3495FB
                        padding-left 20rpx
                        border-left 2rpx solid #D7D7D7
            .total-list
                display flex
                width 100%
                margin-top 15rpx
                li
                    flex 1
                    padding 0 4rpx
                    p
                        font-size 8rpx
                        color #979EA7
                        height 32rpx
                        // line-height 30rpx
                        text-align center
                    // display flex
                    // align-items center
                    span
                        width 100%
                        height 40rpx
                        background rgba(250,132,54,0.06)
                        display block
                        text-align center
                        line-height 40rpx
                        color #FA8436
                        font-size 18rpx
                    &:nth-child(2)
                        span
                            background rgba(85,136,241,0.06);
                            color #5588F1
                    &:nth-child(3)
                        span
                            background rgba(85,136,241,0.06);
                            color #5588F1
                    &:nth-child(4)
                        span
                            background rgba(33,189,204,0.06);
                            color #21BDCC
                    i
                        font-size 12rpx
                .active
                    span
                        background rgba(85,136,241,0.06)
                        border 2rpx solid rgba(205,221,254,1)
                        border-radius 6rpx
            .produce-detail
                // height 48rpx
                background rgba(85,136,241,0.06)
                border 2rpx solid rgba(205,221,254,1)
                margin-top 15rpx
                border-radius 6rpx
                >div
                    width 100%
                    display flex
                    padding 4rpx
                    &:nth-of-type(1)
                        padding-bottom 0
                .item-wrapper
                    flex 1
                    text-align center
                    span
                        font-size 16rpx
                        color #5588F1
                    p
                        font-size 10rpx
                        color #979EA7
                .item-active
                    position relative
                    &::before
                        content ""
                        width 0
                        height 0
                        border-width 0 12rpx 12rpx
                        border-style solid
                        border-color transparent transparent rgba(205,221,254,1)
                        position absolute
                        top -18rpx
                        left 50%
                        margin-left -35rpx
                    // z-index 10
                    &::after
                        content ""
                        width 0
                        height 0
                        border-width 0 10rpx 10rpx
                        border-style solid
                        border-color transparent transparent #f7f7f7
                        position absolute
                        top -16rpx
                        left 50%
                        margin-left -33rpx
        // z-index 9

        .chart-wrapper
            margin-top 15rpx
            background #ffffff
            .chart-box
                padding 5rpx
                .chart-name
                    display flex
                    justify-content space-between
                    p
                        height 22rpx
                        line-height 22rpx
                        &:first-child
                            font-size 16rpx
                            color #333333
                            font-weight 600
                            margin 10rpx 0 0 10rpx
                    .btn-type
                        width 124rpx
                        height 100%
                        display flex
                        margin 10rpx 10rpx 0 0
                        span
                            flex 1
                            text-align center
                            font-size 12rpx
                            &:first-child
                                border 2rpx solid rgba(215,215,215,1)
                                border-radius 4rpx 0 0 4rpx
                                border-right none
                            &:last-child
                                border 2rpx solid rgba(215,215,215,1)
                                border-radius 0 4rpx 4rpx 0
                                border-left none
                            &.active-btn
                                color #ffffff
                                background #3495FB
                                border none
                                line-height 26rpx
                .my-chart
                    height 350rpx
        .ranking-wrapper
            background #ffffff
            margin-top 15rpx
            padding 15rpx 0 15rpx 15rpx
            p
                font-size 16rpx
                color #333333
                font-weight 600
            .empty-wrapper
                text-align center
                display block
                padding 20rpx 0
            ul
                .ranking-item
                    display flex
                    padding-top 15rpx
                    .left-img
                        width 35rpx
                        img
                            width 25rpx
                            height 25rpx
                    .right-content
                        flex 1
                        border-bottom 2rpx solid #F0F0F0
                        padding-bottom 15rpx
                        p
                            font-size 15rpx
                            color #444444
                            font-weight 400
                        ol
                            display flex
                            margin-top 10rpx
                            li
                                margin-right 20rpx
                                text-align center
                                width calc((100% - 40rpx)/3)
                                strong
                                    font-size 14rpx
                                    color #50A5FE
                                span
                                    display block
                                    font-size 10rpx
                                    color #979EA7


</style>
